import './recommendations-card.css';
import { APP_TEXT } from '../../const/app-text';
import { ResourceTable } from '../resource-table';
import { ConfidencePills } from '../confidence-pills';
import { colorHexWithOpacity } from '../../const/colors';
import { getCategoryDataByName } from '../../utils/hardcodes';
import { ResourceTableMobile } from '../resource-table-mobile';
import { useBreakpoint } from '../../hooks/utils/use-breakpoint';
import { ConfidenceValue, CONFIDENCE_LABELS } from '../skill-stats/skill-stats-card';
import { ResourceRecommendations } from '../../services/learning-api/types/resource.types';

const cardText = APP_TEXT.pages.recommendation.card;

export interface RecommendationsGroup {
  id: string;
  title: string;
  description: string;
  accentColor: string;
  resources: ResourceRecommendations[];
  overallConfidence?: ConfidenceValue;
  skills: { id: string; title: string; confidence: ConfidenceValue }[];
}

export const RecommendationsCard = ({ group }: { group: RecommendationsGroup }) => {
  const isLgDown = useBreakpoint('lgxl', 'down');

  return (
    <article
      className="recommendationsCard"
      id={`recommendation-group-${group.title.replace(/\s+/g, '-').toLowerCase()}`}
    >
      <div
        className="recommendationsAccent"
        style={{ backgroundColor: group.accentColor }}
        aria-hidden="true"
      />

      <div className="recommendationsCardContent">
        <header className="recommendationsCardHeader">
          <div className="recommendationsCardHeaderLine">
            <h2 className="recommendationsCardTitle">{group.title}</h2>
            <span className="recommendationsCardTitleConfidenceText">
              {cardText.overallConfidence}
            </span>
          </div>
          <div className="recommendationsCardHeaderLine">
            <p className="recommendationsCardDescription">{group.description}</p>
            <div className="recommendationsRowRight">
              <span className="recommendationsOverallValue">
                {CONFIDENCE_LABELS[group.overallConfidence ?? 1]}
              </span>
              <ConfidencePills
                value={group.overallConfidence ?? 1}
                color={group.accentColor}
                large
              />
            </div>
          </div>
        </header>

        <section
          className="recommendationsTable"
          aria-label={group.title}
        >
          {isLgDown ? (
            <ResourceTableMobile
              resources={group.resources}
              getCategoryColor={(category: string) =>
                colorHexWithOpacity(getCategoryDataByName(category).color, 0.5)
              }
              source="RecommendationPage"
              enableHideRecommendations={true}
              enableResourceBookmarking={true}
            />
          ) : (
            <ResourceTable
              resources={group.resources}
              getCategoryColor={(category: string) =>
                colorHexWithOpacity(getCategoryDataByName(category).color, 0.5)
              }
              source="RecommendationPage"
              enableHideRecommendations={true}
              enableResourceBookmarking={true}
            />
          )}
        </section>
      </div>
    </article>
  );
};
